import React, { useContext } from "react";
import { Box } from "@mui/material";
import { ParcelsHandled } from "./ParcelsHandled";
import { VolumeHandled } from "./VolumeHandled";
import { DScanSuccess } from "./DScan";
import { ClearCustomsFilter } from "./Filter";
import { ParcelsCleared } from "./ParcelsCleard";
import { ThroughputChart } from "./Throughput";
import { Summary } from "./Summary";
import { EcUserDataContext } from "@eclear-ag/ec-common-ui";
import { RedirectionButton } from "../tools/RedirectionButton";
import { DND } from "../../../components/dnd";
import { canAccessClearCustoms } from "../tools/tool";

const TODAY = new Date()?.toISOString()?.split("T")[0];

export const ClearCustoms = () => {
  const { userData } = useContext(EcUserDataContext);
  const userSubs = userData?.userInfo?.userSubscriptions;
  const isLoading = userSubs == null;
  const isSubscribedToClearCustoms = canAccessClearCustoms({ userData });

  if (isLoading) return null;
  if (!isSubscribedToClearCustoms) return null;

  const defaultComponents = [
    { id: "summary", component: Summary, name: "Summary" },
    {
      id: "parcels_handled",
      component: ParcelsHandled,
      name: "ParcelsHandled"
    },
    { id: "volume_handled", component: VolumeHandled, name: "VolumeHandled" },
    { id: "throughput", component: ThroughputChart, name: "ThroughputChart" },
    { id: "dscan_success", component: DScanSuccess, name: "DScanSuccess" },
    { id: "customs_cleared", component: ParcelsCleared, name: "ParcelsCleared" }
  ];

  if (!isSubscribedToClearCustoms) return null;

  return (
    <Box
      sx={{
        paddingBottom: "1rem",
        display: "flex",
        gap: "1rem",
        flexDirection: "column",
      }}
    >
      <RedirectionButton />
      <ClearCustomsFilter />
      <DND defaultComponents={defaultComponents} today={TODAY} />
    </Box>
  );
};
